import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import CreateRepository from "../Repositories/CreateRepository";

class CreateBloc {
  createChannel = new Subject();
  detailChannel = new Subject();
  getProjectionChannel = new Subject();
  regionCountryChannel = new Subject();
  regionProvinceChannel = new Subject();
  regionCityChannel = new Subject();
  educationChannel = new Subject();
  rankChannel = new Subject();
  positionChannel = new Subject();
  workUnitChannel = new Subject();
  agamaGajiWebChannel = new Subject();
  satkerGajiWebChannel = new Subject();
  bankChannel = new Subject();
  bankSpanGajiWebChannel = new Subject();
  empCategoriesChannel = new Subject();
  employeeChannel = new Subject();
  listCandidateChannel = new Subject();
  detailCandidateChannel = new Subject();
  deleteCandidateChannel = new Subject();
  createDecreeCollectiveChannel = new Subject();
  detailDecreeCollectiveChannel = new Subject();
  downloadDraftSKChannel = new Subject();
  downloadSKCollectiveChannel = new Subject();
  importExcelChannel = new Subject();
  repository = new CreateRepository();
  constructor() {
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.detailChannel.next({ status: apiResponse.INITIAL });
    this.getProjectionChannel.next({ status: apiResponse.INITIAL });
    this.regionCountryChannel.next({ status: apiResponse.INITIAL });
    this.regionProvinceChannel.next({ status: apiResponse.INITIAL });
    this.regionCityChannel.next({ status: apiResponse.INITIAL });
    this.educationChannel.next({ status: apiResponse.INITIAL });
    this.rankChannel.next({ status: apiResponse.INITIAL });
    this.positionChannel.next({ status: apiResponse.INITIAL });
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.agamaGajiWebChannel.next({ status: apiResponse.INITIAL });
    this.satkerGajiWebChannel.next({ status: apiResponse.INITIAL });
    this.bankChannel.next({ status: apiResponse.INITIAL });
    this.bankSpanGajiWebChannel.next({ status: apiResponse.INITIAL });
    this.empCategoriesChannel.next({ status: apiResponse.INITIAL });
    this.employeeChannel.next({ status: apiResponse.INITIAL });
    this.listCandidateChannel.next({ status: apiResponse.INITIAL });
    this.detailCandidateChannel.next({ status: apiResponse.INITIAL });
    this.deleteCandidateChannel.next({ status: apiResponse.INITIAL });
    this.createDecreeCollectiveChannel.next({ status: apiResponse.INITIAL });
    this.detailDecreeCollectiveChannel.next({ status: apiResponse.INITIAL });
    this.downloadDraftSKChannel.next({ status: apiResponse.INITIAL });
    this.downloadSKCollectiveChannel.next({ status: apiResponse.INITIAL });
    this.importExcelChannel.next({ status: apiResponse.INITIAL });
  }

  fetchCreate = async (query) => {
    try {
      this.createChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCreate(query)
        .then((result) => {
          this.createChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDetailPeriod = async (query) => {
    try {
      this.detailChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDetailPeriod(query)
        .then((result) => {
          this.detailChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchGetProjection = async (query) => {
    try {
      this.getProjectionChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchGetProjection(query)
        .then((result) => {
          this.getProjectionChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getProjectionChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchRegionCountry = async (query) => {
    try {
      this.regionCountryChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRegionCountry(query)
        .then((result) => {
          this.regionCountryChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.regionCountryChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchRegionProvince = async (query) => {
    try {
      this.regionProvinceChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRegionProvince(query)
        .then((result) => {
          this.regionProvinceChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.regionProvinceChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchRegionCity = async (query) => {
    try {
      this.regionCityChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRegionCity(query)
        .then((result) => {
          this.regionCityChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.regionCityChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchEducation = async (query) => {
    try {
      this.educationChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEducation(query)
        .then((result) => {
          this.educationChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.educationChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchRank = async (query) => {
    try {
      this.rankChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRank(query)
        .then((result) => {
          this.rankChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rankChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchPosition = async (query) => {
    try {
      this.positionChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchPosition(query)
        .then((result) => {
          this.positionChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.positionChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchWorkUnit = async (query) => {
    try {
      this.workUnitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchWorkUnit(query)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchAgamaGajiWeb = async (query) => {
    try {
      this.agamaGajiWebChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchAgamaGajiWeb(query)
        .then((result) => {
          this.agamaGajiWebChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.agamaGajiWebChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchSatkerGajiWeb = async (query) => {
    try {
      this.satkerGajiWebChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchSatkerGajiWeb(query)
        .then((result) => {
          this.satkerGajiWebChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.satkerGajiWebChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchBank = async (query) => {
    try {
      this.bankChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchBank(query)
        .then((result) => {
          this.bankChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.bankChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchBankSpanGajiWeb = async (query) => {
    try {
      this.bankSpanGajiWebChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchBankSpanGajiWeb(query)
        .then((result) => {
          this.bankSpanGajiWebChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.bankSpanGajiWebChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchEmpCategories = async (query) => {
    try {
      this.empCategoriesChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmpCategories(query)
        .then((result) => {
          this.empCategoriesChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.empCategoriesChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchEmployee = async (query) => {
    try {
      this.employeeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployee(query)
        .then((result) => {
          this.employeeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchListCandidate = async (query) => {
    try {
      this.listCandidateChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchListCandidate(query)
        .then((result) => {
          this.listCandidateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listCandidateChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDetailCandidate = async (query) => {
    try {
      this.detailCandidateChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDetailCandidate(query)
        .then((result) => {
          this.detailCandidateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailCandidateChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDeleteCandidate = async (query) => {
    try {
      this.deleteCandidateChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDeleteCandidate(query)
        .then((result) => {
          this.deleteCandidateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.deleteCandidateChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchCreateDecreeCollective = async (query) => {
    try {
      this.createDecreeCollectiveChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCreateDecreeCollective(query)
        .then((result) => {
          this.createDecreeCollectiveChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createDecreeCollectiveChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDetailDecreeCollective = async (query) => {
    try {
      this.detailDecreeCollectiveChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDetailDecreeCollective(query)
        .then((result) => {
          this.detailDecreeCollectiveChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailDecreeCollectiveChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDownloadDraftSK = async (query) => {
    try {
      this.downloadDraftSKChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDownloadDraftSK(query)
        .then((result) => {
          this.downloadDraftSKChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.downloadDraftSKChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDownloadSKCollective = async (query) => {
    try {
      this.downloadSKCollectiveChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDownloadSKCollective(query)
        .then((result) => {
          this.downloadSKCollectiveChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.downloadSKCollectiveChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchImportExcel = async (query) => {
    try {
      this.importExcelChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchImportExcel(query)
        .then((result) => {
          this.importExcelChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.importExcelChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };
}

export default CreateBloc;
